export function returnValueHelper(state, value1, value2) {
    return state ? value1 : value2;
}
//# sourceMappingURL=ReturnValueHelper.js.map